import React from 'react'
interface EditTabProps {
  label: string
  isActive: boolean
  onClick: () => void
}

const EditTab: React.FC<EditTabProps> = ({ label, isActive, onClick }) => {
  return (
    <li
      className={`text-center rounded-lg py-2 md:p-2 whitespace-nowrap transition-colors duration-300 cursor-pointer
        ${isActive ? 'text-white bg-black hover:bg-gray-800' : 'text-gray-500 hover:bg-gray-100'} 
        w-full md:w-[160px]`}
      onClick={(e) => {
        e.preventDefault()
        onClick()
      }}
    >
      <a
        className="block text-sm md:text-base font-medium"
        data-toggle="tab"
        href={`#${label}`}
        role="tablist"
      >
        {label}
      </a>
    </li>
  )
}

export default EditTab
